import * as transform from '../lib/transform'
import { captureException } from '../lib/sentry'

export const request = (req) => {
  const newReq = { ...req }

  newReq.data = transform.toSnakeCase(newReq.data)
  newReq.params = transform.toSnakeCase(newReq.params)

  return newReq
}

export const responseSuccess = (res) => {
  const newRes = { ...res }

  newRes.data = transform.toCamelCase(newRes.data)

  return newRes
}

export const responseError = (err) => {
  const newErr = { ...err }

  const response = {
    data: transform.toCamelCase(newErr?.response?.data)
  }

  newErr.response = response

  if (![401, 403].includes(err?.response?.status)) {
    captureException(err)
  }

  return Promise.reject(newErr)
}
